import { MessageCircle } from 'lucide-react';

interface HeaderContactProps {
  contactValue: string;
  ctaText?: string;
  icon?: React.ReactNode;
}

function HeaderContact({ contactValue, ctaText = "Get Demo", icon }: HeaderContactProps) {
  return (
    <span className="flex items-center space-x-1 text-sm text-gray-500 font-bold">
      {icon || <MessageCircle size={16} className="text-gray-500" />}
      <span className="md:hidden">{contactValue}</span>
      <span className="hidden md:inline">{ctaText}: {contactValue}</span>
    </span>
  );
}

export default HeaderContact; 